export const stories = [
  {
    org: 'Post',
    year: 2025,
    link: 'https://www.washingtonpost.com/sports/interactive/2025/parlay-popularity-odds-sportsbooks/',
    title: 'Americans can’t stop betting parlays. Sportsbooks are cashing in.',
    path: 'parlays'
  },
  {
    org: 'Post',
    year: 2025,
    link: 'https://www.washingtonpost.com/food/interactive/2025/recipe-ingredient-quiz/',
    title: 'Ready for a food fight? Take our quiz on divisive recipe ingredients.',
    path: 'recipes',
  },
  {
    org: 'Post',
    year: 2025,
    link: 'https://www.washingtonpost.com/politics/interactive/2025/white-house-budget-federal-government/',
    title: 'The White House’s plan to downsize the federal government, in charts',
    path: 'fedGovCuts',
  },
  {
    org: 'Post',
    year: 2024,
    link: 'https://www.washingtonpost.com/elections/interactive/2024/11/05/compare-2020-2024-presidential-results/',
    title: 'How counties are shifting in the 2024 presidential election',
    path: 'countyShifts',
  },
  {
    org: 'Post',
    year: 2024,
    link: 'https://www.washingtonpost.com/elections/interactive/2024/2024-swing-states-trump-harris/',
    title: 'A guide to the 7 battleground states that could swing the election',
    path: 'swingStateGuide',
  },
  {
    org: 'Post',
    year: 2024,
    link: 'https://www.washingtonpost.com/business/interactive/2024/campaign-spending-fast-food-mcdonalds/',
    title: 'The vast divide between Republicans and Democrats over fast food',
    path: 'fecFood'
  },
  {
    org: 'Post',
    year: 2024,
    link: 'https://www.washingtonpost.com/elections/interactive/2024/presidential-polling-averages/',
    title: "Who is ahead in Harris vs. Trump 2024 presidential polls right now?",
    path: 'polls',
  },
  {
    org: 'Post',
    year: 2024,
    link: 'https://www.washingtonpost.com/sports/olympics/interactive/2024/how-is-us-gymnastics-team-picked/',
    title: "Think you can build a gold medal U.S. gymnastics team? Try it.",
    path: 'gymnastics'
  },
  {
    org: 'Post',
    year: 2024,
    link: 'https://www.washingtonpost.com/politics/interactive/2024/house-control-republican-margin/',
    title: "Republicans’ House majority is their smallest in decades, and shrinking",
    path: 'majority'
  },
  {
    org: 'Post',
    year: 2023,
    link: 'https://www.washingtonpost.com/politics/2023/08/09/small-town-voting-trump/',
    title: 'Small towns don’t vote like other rural areas',
    path: 'smallTowns'
  },
  {
    org: 'Post',
    year: 2023,
    link: 'https://www.washingtonpost.com/parenting/interactive/2023/lego-bricks-colors-history/?itid=ap_katiperry',
    title: 'How Lego bricks went from five colors to nearly 200',
    path: 'lego',
  },
  // {
  //   org: 'Post',
  //   year: 2022,
  //   link: 'https://www.washingtonpost.com/politics/interactive/2022/abortion-rights-election/',
  //   title: "Here’s how abortion access fared in the midterm elections in nine states",
  // },
    {
    org: 'AP',
    year: 2023,
    link: 'https://apnews.com/article/adrift-investigation-migrants-mauritania-tobago-663a576e233cb4b363f5eda8d5969b5a',
    title: "Adrift: An AP investigation into deadly migrant voyage",
    path: 'adrift',
  },
  {
    org: 'AP',
    year: 2021,
    link: 'https://projects.apnews.com/features/2021/polar-bears-sea-ice/index.html',
    title: "Arctic sea ice is disappearing and it’s harming polar bears",
    path: 'polarBears'
  },
  {
    org: 'AP',
    year: 2021,
    link: 'https://interactives.ap.org/gaza-toll-of-war/gaza-toll-one-neighborhood.html',
    title: "Gaza's toll: After four wars, Gaza families struggle with the cost",
    path: 'gaza'
  },
  // {
  //   org: 'AP',
  //   year: 2021,
  //   link: 'https://projects.apnews.com/features/2021/gaza-toll-of-war/gaza-toll-by-the-numbers.html',
  //   title: 'The deepening costs of 4 Gaza wars in 13 years, in 4 charts',
  // },
]
